/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementExportZipResponse } from './EventManagementExportZipResponse';

export type EventManagementExportZipResponseApiRespoonse = {
    data?: EventManagementExportZipResponse;
    status?: EventManagementExportZipResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementExportZipResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

